<BaseModal
  :model-value="modelValue"
  class="nb-confirm-modal"
  :width="'390px'"
  :bottom-sheet-on-mobile="true"
  :show-close-button="true"
  @update:model-value="$emit('update:modelValue', $event)"
>
  <template #header></template>

  <div class="nb-confirm-modal__body">
    <span class="nb-confirm-modal__icon iconfont-trash" aria-hidden="true"></span>
    <h3 class="nb-confirm-modal__title">{{ title }}</h3>
    <p class="nb-confirm-modal__message">
      <slot>{{ message }}</slot>
    </p>
  </div>

  <template #footer>
    <button class="checkout-v2-btn" @click="onConfirm">
      {{ confirmText }}
    </button>
  </template>
</BaseModal>
